module.exports = __webpack_public_path__ + "media/images/favicon-dcf2155ebcd96b1e80169d3ba9c566e7.ico";